import MyCustomLogo from "../../public/element_logo.png";
import Image from 'next/image';


interface ImageProps {
  className?: string;
}

export const ElementLogo = (props: ImageProps) => {
  return (
    // <svg
    //   width="10"
    //   height="10"
    //   viewBox="0 0 10 10"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   {...props}
    // >
    <div>
    <Image 
      src={MyCustomLogo} 
      alt="Custom Logo" 
      width={80} 
      height={80} 
    />
      <title>Element</title>
      <g clipPath="url(#clip0_3414_6245)">
        <path
          d="M5.00039 0C4.66795 0 4.36521 0.170703 3.75972 0.51211L1.64106 1.70672C1.03557 2.04813 0.732828 2.21883 0.566609 2.5C0.400391 2.78117 0.400391 3.12257 0.400391 3.80539V6.19461C0.400391 6.53491 0.745443 6.74615 1.05621 6.60747C1.96439 6.20218 2.89071 5.83057 3.83337 5.49397C3.90187 5.48079 3.97292 5.4904 4.03517 5.52129C4.09742 5.55217 4.14729 5.60255 4.17682 5.66438C4.20635 5.7262 4.21385 5.79591 4.19811 5.86239C4.18237 5.92887 4.1443 5.9883 4.08998 6.03118C3.24117 6.53229 2.41401 7.06439 1.61009 7.626C1.36866 7.79467 1.38452 8.14862 1.64106 8.29328L3.75972 9.48789C4.36521 9.8293 4.66795 10 5.00039 10C5.33283 10 5.63557 9.8293 6.24106 9.48789L8.35972 8.29328C8.96521 7.95187 9.26795 7.78117 9.43417 7.5C9.60039 7.21883 9.60039 6.87742 9.60039 6.19461V3.80539C9.60039 3.12257 9.60039 2.78117 9.43417 2.5C9.26795 2.21883 8.96521 2.04813 8.35972 1.70672L6.24106 0.51211C5.63557 0.170703 5.33283 0 5.00039 0Z"
          fill="#0065F5"
        />
        <path
          d="M6.67667 2.42813C6.80855 2.07978 6.87448 1.9056 6.99 1.89876C6.99718 1.89833 7.00438 1.89833 7.01156 1.89876C7.12708 1.9056 7.19301 2.07978 7.32489 2.42813L7.49286 2.87184C7.51925 2.94156 7.53245 2.97641 7.55802 3.00233C7.55978 3.00412 7.56159 3.00588 7.56344 3.00759C7.59014 3.03241 7.62605 3.04522 7.69788 3.07083L8.15503 3.23386C8.51395 3.36186 8.6934 3.42586 8.70045 3.53797C8.70089 3.54494 8.70089 3.55193 8.70045 3.55891C8.6934 3.67102 8.51395 3.73502 8.15503 3.86302L7.69788 4.02605C7.62605 4.05166 7.59014 4.06447 7.56344 4.08929C7.56159 4.091 7.55978 4.09276 7.55802 4.09455C7.53245 4.12047 7.51925 4.15532 7.49286 4.22504L7.32489 4.66875C7.19301 5.0171 7.12708 5.19128 7.01156 5.19812C7.00438 5.19855 6.99718 5.19855 6.99 5.19812C6.87448 5.19128 6.80855 5.0171 6.67667 4.66875L6.5087 4.22504C6.48231 4.15532 6.46911 4.12047 6.44354 4.09455C6.44178 4.09276 6.43997 4.091 6.43812 4.08929C6.41142 4.06447 6.37551 4.05166 6.30368 4.02605L5.84653 3.86302C5.48761 3.73502 5.30816 3.67102 5.30111 3.55891C5.30067 3.55193 5.30067 3.54494 5.30111 3.53797C5.30816 3.42586 5.48761 3.36186 5.84653 3.23386L6.30368 3.07083C6.37551 3.04522 6.41142 3.03241 6.43812 3.00759C6.43997 3.00588 6.44178 3.00412 6.44354 3.00233C6.46911 2.97641 6.48231 2.94156 6.5087 2.87184L6.67667 2.42813Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3414_6245">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
      </div>
  );
};

export const FarcasterIconLightTheme = (props: ImageProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Farcaster icon</title>
      <g clipPath="url(#clip0_3414_7857)">
        <path
          d="M15.0619 0.833008H4.93844C2.67134 0.833008 0.833496 2.67085 0.833496 4.93795V15.0614C0.833496 17.3285 2.67134 19.1663 4.93844 19.1663H15.0619C17.329 19.1663 19.1668 17.3285 19.1668 15.0614V4.93795C19.1668 2.67085 17.329 0.833008 15.0619 0.833008Z"
          stroke="#8A8AA3"
          strokeWidth="1.5"
        />
        <path
          d="M5.62109 3.84668H14.2207V16.1544H12.9584V8.84995H12.946C12.8065 7.29186 11.5054 6.07083 9.92088 6.07083C8.33646 6.07083 7.03532 7.29186 6.8958 8.84995H6.88343V16.1544H5.62109V3.84668Z"
          fill="#8A8AA3"
        />
        <path
          d="M3.3335 5.59277L3.84631 7.33967H4.28024V14.4066C4.06238 14.4066 3.88576 14.5844 3.88576 14.8037V15.2801H3.80687C3.589 15.2801 3.41239 15.4579 3.41239 15.6771V16.1536H7.83054V15.6771C7.83054 15.4579 7.65392 15.2801 7.43606 15.2801H7.35716V14.8037C7.35716 14.5844 7.18055 14.4066 6.96269 14.4066H6.48931V5.59277H3.3335Z"
          fill="#8A8AA3"
        />
        <path
          d="M13.0373 14.4066C12.8194 14.4066 12.6428 14.5844 12.6428 14.8037V15.2801H12.5639C12.346 15.2801 12.1694 15.4579 12.1694 15.6771V16.1536H16.5875V15.6771C16.5875 15.4579 16.4109 15.2801 16.1931 15.2801H16.1142V14.8037C16.1142 14.5844 15.9375 14.4066 15.7197 14.4066V7.33967H16.1536L16.6664 5.59277H13.5106V14.4066H13.0373Z"
          fill="#8A8AA3"
        />
      </g>
      <defs>
        <clipPath id="clip0_3414_7857">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FarcasterIconDarkTheme = (props: ImageProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Farcaster icon</title>
      <g clipPath="url(#clip0_3414_6273)">
        <path
          d="M15.0616 0.833008H4.93819C2.6711 0.833008 0.833252 2.67085 0.833252 4.93795V15.0614C0.833252 17.3285 2.6711 19.1663 4.93819 19.1663H15.0616C17.3287 19.1663 19.1666 17.3285 19.1666 15.0614V4.93795C19.1666 2.67085 17.3287 0.833008 15.0616 0.833008Z"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="1.5"
        />
        <path
          d="M5.62134 3.84668H14.221V16.1544H12.9586V8.84995H12.9462C12.8067 7.29186 11.5056 6.07083 9.92112 6.07083C8.3367 6.07083 7.03556 7.29186 6.89605 8.84995H6.88367V16.1544H5.62134V3.84668Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M3.33325 5.59277L3.84607 7.33967H4.27999V14.4066C4.06214 14.4066 3.88552 14.5844 3.88552 14.8037V15.2801H3.80663C3.58876 15.2801 3.41214 15.4579 3.41214 15.6771V16.1536H7.83029V15.6771C7.83029 15.4579 7.65368 15.2801 7.43582 15.2801H7.35692V14.8037C7.35692 14.5844 7.18031 14.4066 6.96244 14.4066H6.48907V5.59277H3.33325Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M13.0375 14.4066C12.8196 14.4066 12.643 14.5844 12.643 14.8037V15.2801H12.5641C12.3463 15.2801 12.1697 15.4579 12.1697 15.6771V16.1536H16.5878V15.6771C16.5878 15.4579 16.4112 15.2801 16.1933 15.2801H16.1144V14.8037C16.1144 14.5844 15.9378 14.4066 15.7199 14.4066V7.33967H16.1538L16.6667 5.59277H13.5108V14.4066H13.0375Z"
          fill="white"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_3414_6273">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GithubIconLightTheme = (props: ImageProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>GitHub icon</title>
      <g clipPath="url(#clip0_3414_7862)">
        <path
          d="M1.00912 4.62437C0.835263 5.9175 0.833496 7.61911 0.833496 9.99967C0.833496 12.3803 0.835263 14.0818 1.00912 15.375C1.17975 16.6442 1.50229 17.3944 2.05387 17.946C2.60547 18.4976 3.35568 18.8201 4.62485 18.9908C5.91798 19.1646 7.61958 19.1663 10.0002 19.1663C12.3807 19.1663 14.0823 19.1646 15.3755 18.9908C16.6447 18.8201 17.3948 18.4976 17.9465 17.946M1.00912 4.62437C1.17975 3.3552 1.5023 2.60499 2.05388 2.0534C2.60548 1.5018 3.35569 1.17927 4.62485 1.00863C5.91798 0.834774 7.61958 0.833008 10.0002 0.833008C12.3807 0.833008 14.0823 0.834774 15.3755 1.00863C16.6447 1.17927 17.3948 1.50179 17.9465 2.05338M17.9465 17.946C18.4981 17.3943 18.8206 16.6442 18.9912 15.375C19.1651 14.0818 19.1668 12.3803 19.1668 9.99967C19.1668 7.61911 19.1651 5.9175 18.9912 4.62436C18.8206 3.35519 18.4981 2.60498 17.9465 2.05338"
          stroke="#8A8AA3"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.50438 16.0779C7.50438 16.0779 6.00049 16.0779 4.50049 14.0787M12.0593 19.167V14.8429C12.0593 14.4795 11.9511 14.1636 11.7767 13.8782C11.6571 13.6825 11.739 13.4047 11.9552 13.3433C13.7452 12.8351 15.0005 12.018 15.0005 9.30758C15.0005 8.60291 14.7769 7.9404 14.3839 7.3638C14.1884 7.07684 14.1932 7.1034 14.2751 6.76419C14.4187 6.16767 14.4303 5.53925 14.2697 4.95305C14.2169 4.76035 14.1037 4.64796 13.8988 4.66966C13.6331 4.69781 13.173 4.82363 12.4905 5.26392C12.2224 5.43692 12.0883 5.52342 11.9702 5.54277C11.8521 5.56212 11.6943 5.52159 11.3785 5.44053C10.9468 5.32968 10.5019 5.27018 10.0005 5.27018C9.49908 5.27018 9.05416 5.32968 8.6225 5.44053C8.30669 5.52159 8.14889 5.56212 8.03079 5.54277C7.91269 5.52342 7.77862 5.43692 7.51048 5.26392C6.82802 4.82363 6.36789 4.69781 6.10215 4.66966C5.89729 4.64796 5.7841 4.76035 5.7313 4.95305C5.57065 5.53925 5.58216 6.16769 5.72592 6.7642C5.80767 7.10342 5.81262 7.07684 5.61703 7.3638C5.22405 7.9404 5.00049 8.60291 5.00049 9.30758C5.00049 12.018 6.25575 12.8351 8.04579 13.3433C8.26199 13.4047 8.34391 13.6825 8.22429 13.8782C8.04989 14.1636 7.94167 14.4795 7.94167 14.8429V19.167"
          stroke="#8A8AA3"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_3414_7862">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GithubIconDarkTheme = (props: ImageProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>GitHub icon</title>
      <g clipPath="url(#clip0_3414_6278)">
        <path
          d="M1.00888 4.62437C0.835019 5.9175 0.833252 7.61911 0.833252 9.99967C0.833252 12.3803 0.835019 14.0818 1.00888 15.375C1.17951 16.6442 1.50204 17.3944 2.05363 17.946C2.60523 18.4976 3.35544 18.8201 4.6246 18.9908C5.91773 19.1646 7.61933 19.1663 9.99992 19.1663C12.3805 19.1663 14.0821 19.1646 15.3753 18.9908C16.6444 18.8201 17.3946 18.4976 17.9463 17.946M1.00888 4.62437C1.17951 3.3552 1.50205 2.60499 2.05364 2.0534C2.60524 1.5018 3.35544 1.17927 4.6246 1.00863C5.91773 0.834774 7.61933 0.833008 9.99992 0.833008C12.3805 0.833008 14.0821 0.834774 15.3753 1.00863C16.6444 1.17927 17.3946 1.50179 17.9463 2.05338M17.9463 17.946C18.4978 17.3943 18.8203 16.6442 18.991 15.375C19.1648 14.0818 19.1666 12.3803 19.1666 9.99967C19.1666 7.61911 19.1648 5.9175 18.991 4.62436C18.8203 3.35519 18.4978 2.60498 17.9463 2.05338"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.50414 16.0779C7.50414 16.0779 6.00024 16.0779 4.50024 14.0787M12.0591 19.167V14.8429C12.0591 14.4795 11.9508 14.1636 11.7764 13.8782C11.6568 13.6825 11.7388 13.4047 11.9549 13.3433C13.7449 12.8351 15.0003 12.018 15.0003 9.30758C15.0003 8.60291 14.7767 7.9404 14.3837 7.3638C14.1882 7.07684 14.193 7.1034 14.2748 6.76419C14.4185 6.16767 14.4301 5.53925 14.2694 4.95305C14.2167 4.76035 14.1034 4.64796 13.8986 4.66966C13.6328 4.69781 13.1728 4.82363 12.4903 5.26392C12.2222 5.43692 12.0881 5.52342 11.9699 5.54277C11.8518 5.56212 11.6941 5.52159 11.3783 5.44053C10.9466 5.32968 10.5017 5.27018 10.0003 5.27018C9.49884 5.27018 9.05392 5.32968 8.62225 5.44053C8.30644 5.52159 8.14864 5.56212 8.03054 5.54277C7.91244 5.52342 7.77838 5.43692 7.51024 5.26392C6.82778 4.82363 6.36764 4.69781 6.1019 4.66966C5.89704 4.64796 5.78385 4.76035 5.73105 4.95305C5.57041 5.53925 5.58191 6.16769 5.72568 6.7642C5.80743 7.10342 5.81238 7.07684 5.61679 7.3638C5.2238 7.9404 5.00024 8.60291 5.00024 9.30758C5.00024 12.018 6.2555 12.8351 8.04554 13.3433C8.26174 13.4047 8.34367 13.6825 8.22404 13.8782C8.04964 14.1636 7.94143 14.4795 7.94143 14.8429V19.167"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_3414_6278">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const XIconLightTheme = (props: ImageProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>X icon</title>
      <g clipPath="url(#clip0_3414_7865)">
        <path
          d="M1.00912 4.62437C0.835263 5.9175 0.833496 7.61911 0.833496 9.99967C0.833496 12.3803 0.835263 14.0818 1.00912 15.375C1.17975 16.6442 1.50229 17.3944 2.05387 17.946C2.60547 18.4976 3.35568 18.8201 4.62485 18.9908C5.91798 19.1646 7.61958 19.1663 10.0002 19.1663C12.3807 19.1663 14.0823 19.1646 15.3755 18.9908C16.6447 18.8201 17.3948 18.4976 17.9465 17.946M1.00912 4.62437C1.17975 3.3552 1.5023 2.60499 2.05388 2.0534C2.60548 1.5018 3.35569 1.17927 4.62485 1.00863C5.91798 0.834774 7.61958 0.833008 10.0002 0.833008C12.3807 0.833008 14.0823 0.834774 15.3755 1.00863C16.6447 1.17927 17.3948 1.50179 17.9465 2.05338M17.9465 17.946C18.4981 17.3943 18.8206 16.6442 18.9912 15.375C19.1651 14.0818 19.1668 12.3803 19.1668 9.99967C19.1668 7.61911 19.1651 5.9175 18.9912 4.62436C18.8206 3.35519 18.4981 2.60498 17.9465 2.05338"
          stroke="#8A8AA3"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.73633 15.2636L9.15067 10.8494M9.15067 10.8494L4.73633 4.7373H7.66031L10.8484 9.15156M9.15067 10.8494L12.3387 15.2636H15.2627L10.8484 9.15156M10.8484 9.15156L15.2627 4.7373"
          stroke="#8A8AA3"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3414_7865">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const XIconDarkTheme = (props: ImageProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>X icon</title>
      <g clipPath="url(#clip0_3414_6281)">
        <path
          d="M1.00888 4.62437C0.835019 5.9175 0.833252 7.61911 0.833252 9.99967C0.833252 12.3803 0.835019 14.0818 1.00888 15.375C1.17951 16.6442 1.50204 17.3944 2.05363 17.946C2.60523 18.4976 3.35544 18.8201 4.6246 18.9908C5.91773 19.1646 7.61933 19.1663 9.99992 19.1663C12.3805 19.1663 14.0821 19.1646 15.3753 18.9908C16.6444 18.8201 17.3946 18.4976 17.9463 17.946M1.00888 4.62437C1.17951 3.3552 1.50205 2.60499 2.05364 2.0534C2.60524 1.5018 3.35544 1.17927 4.6246 1.00863C5.91773 0.834774 7.61933 0.833008 9.99992 0.833008C12.3805 0.833008 14.0821 0.834774 15.3753 1.00863C16.6444 1.17927 17.3946 1.50179 17.9463 2.05338M17.9463 17.946C18.4978 17.3943 18.8203 16.6442 18.991 15.375C19.1648 14.0818 19.1666 12.3803 19.1666 9.99967C19.1666 7.61911 19.1648 5.9175 18.991 4.62436C18.8203 3.35519 18.4978 2.60498 17.9463 2.05338"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.73633 15.2636L9.15067 10.8494M9.15067 10.8494L4.73633 4.7373H7.66031L10.8484 9.15156M9.15067 10.8494L12.3387 15.2636H15.2627L10.8484 9.15156M10.8484 9.15156L15.2627 4.7373"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3414_6281">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ZapIcon = (props: ImageProps) => {
  return (
    <Image 
      src={MyCustomLogo} 
      alt="Custom Logo" 
      width={25} 
      height={25} 
      {...props} 
    />
  );
};

export const BNBIcon = (props: ImageProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>BNB icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C18.6279 0 24 5.37212 24 12C24 18.6279 18.6279 24 12 24C5.37212 24 0 18.6279 0 12C0 5.37212 5.37212 0 12 0Z"
        fill="#F0B90B"
      />
      <path
        d="M6.5951 11.9995L6.60375 15.1726L9.2999 16.7591V18.6168L5.02586 16.1101V11.0716L6.5951 11.9995ZM6.5951 8.82644V10.6755L5.0249 9.74663V7.8976L6.5951 6.96875L8.17298 7.8976L6.5951 8.82644ZM10.4259 7.8976L11.9961 6.96875L13.5739 7.8976L11.9961 8.82644L10.4259 7.8976Z"
        fill="white"
      />
      <path
        d="M7.72974 14.5149V12.6572L9.29993 13.5861V15.4351L7.72974 14.5149ZM10.4259 17.4245L11.9961 18.3534L13.574 17.4245V19.2736L11.9961 20.2024L10.4259 19.2736V17.4245ZM15.8259 7.8976L17.3961 6.96875L18.974 7.8976V9.74663L17.3961 10.6755V8.82644L15.8259 7.8976ZM17.3961 15.1726L17.4047 11.9995L18.9749 11.0707V16.1091L14.7009 18.6159V16.7582L17.3961 15.1726Z"
        fill="white"
      />
      <path
        d="M16.2701 14.5149L14.7 15.4351V13.5861L16.2701 12.6572V14.5149Z"
        fill="white"
      />
      <path
        d="M16.2701 9.48438L16.2788 11.3421L13.5749 12.9286V16.1094L12.0047 17.0296L10.4345 16.1094V12.9286L7.7307 11.3421V9.48438L9.30762 8.55553L11.9951 10.1498L14.699 8.55553L16.2769 9.48438H16.2701ZM7.72974 6.31226L11.9961 3.79688L16.2701 6.31226L14.6999 7.24111L11.9961 5.64688L9.29993 7.24111L7.72974 6.31226Z"
        fill="white"
      />
    </svg>
  );
};

export const BaseIcon = (props: ImageProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Base icon</title>
      <path
        d="M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7Z"
        fill="#0153FF"
      />
      <path
        d="M7.11038 13C10.3638 13 13.001 10.3675 13.001 7.11975C13.001 3.87197 10.3638 1.23949 7.11038 1.23949C4.02395 1.23949 1.49215 3.60947 1.24048 6.62533H9.0264V7.61416H1.24048C1.49215 10.63 4.02395 13 7.11038 13Z"
        fill="white"
      />
    </svg>
  );
};

export const TronIcon = (props: ImageProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Tron icon</title>
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#FF060A"
      />
      <g clipPath="url(#clip0_3441_3955)">
        <path
          d="M17.5077 10.7308C16.905 10.1743 16.0713 9.32456 15.3923 8.72188L15.3521 8.69375C15.2852 8.64007 15.2099 8.59797 15.1291 8.5692C13.4918 8.26384 5.87196 6.83951 5.7233 6.85759C5.68164 6.86343 5.64183 6.87853 5.60678 6.90179L5.56861 6.93192C5.52161 6.97966 5.48591 7.03732 5.46415 7.10067L5.4541 7.12679V7.26942V7.29152C6.31191 9.68014 9.69897 17.5049 10.3659 19.3411C10.4061 19.4656 10.4825 19.7027 10.6251 19.7147H10.6572C10.7336 19.7147 11.059 19.2848 11.059 19.2848C11.059 19.2848 16.8769 12.2295 17.4655 11.4781C17.5417 11.3856 17.6089 11.286 17.6664 11.1808C17.681 11.0985 17.6741 11.0138 17.6463 10.9349C17.6185 10.856 17.5707 10.7857 17.5077 10.7308ZM12.5516 11.5525L15.0347 9.49331L16.4912 10.8353L12.5516 11.5525ZM11.5874 11.4179L7.31236 7.91429L14.2291 9.18996L11.5874 11.4179ZM11.9731 12.3359L16.3485 11.6308L11.3463 17.6576L11.9731 12.3359ZM6.73178 8.26384L11.2298 12.0808L10.5789 17.6616L6.73178 8.26384Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3441_3955">
          <rect
            width="12.8571"
            height="12.8571"
            fill="white"
            transform="translate(5.14282 6.85742)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SolanaIcon = (props: ImageProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Solana icon</title>
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#202020"
      />
      <g clipPath="url(#clip0_3441_7444)">
        <rect
          width="10"
          height="10"
          transform="translate(7 7)"
          fill="white"
          fillOpacity="0.05"
        />
        <path
          d="M8.62436 14.6327C8.68471 14.5557 8.76768 14.5107 8.85569 14.5107H16.8366C16.9824 14.5107 17.0553 14.7353 16.9522 14.8669L15.3757 16.8784C15.3153 16.9554 15.2324 17.0003 15.1443 17.0003H7.16346C7.01762 17.0003 6.9447 16.7757 7.04779 16.6442L8.62436 14.6327Z"
          fill="url(#paint0_linear_3441_7444)"
        />
        <path
          d="M8.62436 7.12191C8.68722 7.04491 8.7702 7 8.85569 7H16.8366C16.9824 7 17.0553 7.22457 16.9522 7.35611L15.3757 9.36766C15.3153 9.44466 15.2324 9.48957 15.1443 9.48957H7.16346C7.01762 9.48957 6.9447 9.265 7.04779 9.13346L8.62436 7.12191Z"
          fill="url(#paint1_linear_3441_7444)"
        />
        <path
          d="M15.3757 10.8534C15.3153 10.7764 15.2324 10.7314 15.1443 10.7314H7.16346C7.01762 10.7314 6.9447 10.956 7.04779 11.0876L8.62436 13.0991C8.68471 13.1761 8.76768 13.221 8.85569 13.221H16.8366C16.9824 13.221 17.0553 12.9964 16.9522 12.8649L15.3757 10.8534Z"
          fill="url(#paint2_linear_3441_7444)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3441_7444"
          x1="16.0742"
          y1="5.79867"
          x2="8.1484"
          y2="17.6969"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3441_7444"
          x1="13.659"
          y1="4.18956"
          x2="5.73327"
          y2="16.0878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3441_7444"
          x1="14.8589"
          y1="4.98913"
          x2="6.93314"
          y2="16.8874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <clipPath id="clip0_3441_7444">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(7 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};